module.exports = __webpack_public_path__ + "img/transaction-history.1689b00c.png";